var _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBa = function SvgBa(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_21601_3761",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#4171CF"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_21601_3761)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#002395"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 19L1 -1H21V19Z",
    fill: "#FECB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 6L4.44903 7.38197H5.90211L4.72654 8.23607L5.17557 9.61803L4 8.76393L2.82443 9.61803L3.27346 8.23607L2.09789 7.38197H3.55097L4 6Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 10L8.44903 11.382H9.90211L8.72654 12.2361L9.17557 13.618L8 12.7639L6.82443 13.618L7.27346 12.2361L6.09789 11.382H7.55097L8 10Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 14L12.449 15.382H13.9021L12.7265 16.2361L13.1756 17.618L12 16.7639L10.8244 17.618L11.2735 16.2361L10.0979 15.382H11.551L12 14Z",
    fill: "white"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ba.256ac2de1154540b2bca102ef2fb2d1a.svg";